import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';

import { Message } from 'app/seedly-component-library';
import Avatar from 'seedly-component-library/avatar-new';
import { updateUserProfileImage } from 'app/dispatcher/profileDispatcher';
import imageApi from '../../../api/imageApi';

const EditProfileImage = props => {
  const { profile } = props;

  const dispatch = useDispatch();

  // Refs
  const input = useRef(null);

  const onSelect = () => {
    input.current.click();
  };

  const onChangeInput = e => {
    const file = e.target.files[0];
    if (!file) return;
    const fileSize = file.size / 1024 / 1024;
    if (fileSize >= 10) {
      Message.error('Image file size is too large.');
    } else {
      imageApi.uploadImage(file).then((response: any) => {
        if (response.ok) {
          const { temp } = response.data?.data;
          if (temp) {
            dispatch(updateUserProfileImage({ tempImageFileIds: [temp.id] }));
          }
          Message.success('Image uploaded.');
        } else {
          Message.error('Failed to upload image');
        }
      });
    }
  };

  let avatarImage = profile.image;
  if (avatarImage && avatarImage.indexOf('facebook') !== -1) {
    avatarImage += '?type=large';
  }

  return (
    <div className="flex gap-6 w-full items-center lg:flex-row flex-col">
      <Avatar sizeClass="avatar-40" src={avatarImage} name={profile.name} />
      <input
        className="hidden"
        type="file"
        accept="image/*"
        ref={input}
        onChange={onChangeInput}
      />
      <span className="underline" onClick={onSelect}>
        Change profile picture
      </span>
    </div>
  );
};

export default EditProfileImage;
